import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { UnifiedProjectWrapper } from "./ui";

export const createUnifiedProjectWrapper = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    element: createElement(UnifiedProjectWrapper),
    children: [...rest],
  };
};

